window.addEventListener("resize", (event) => {
    hotSpot()
});


const hotSpot = function () {
    let imgHotSpot = document.querySelector(".action_img");
    imgHotSpot = imgHotSpot.offsetWidth
    console.log(imgHotSpot)
    let hotSpots = document.getElementsByClassName("hotspot");
    let hotSpotsInfo = document.getElementsByClassName("hotspot_info");
    let infoPosition = parseInt((120/imgHotSpot)*100) // calculamos el porcentaje [hotspot_info] relacionado a la pantalla
    hotSpots.forEach(function(ele, i, array) {
        var top = parseInt(ele.style.top.replace("%", ""), 10);
        var left = parseInt(ele.style.left.replace("%", ""), 10);

        if(left <= 20){
            hotSpotsInfo[i].style.left = (left + 1) + "%";
            hotSpotsInfo[i].style.top = (top - 10) + "%";
        }
        if(left >= 80){
            hotSpotsInfo[i].style.left = (left - (infoPosition+1)) + "%";
            hotSpotsInfo[i].style.top = (top - 10) + "%";
        }
    });
}   
